import React from "react"
import ScrollPosition from "../../hook/ScrollPosition";

import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const F2floor = () => {
   const scrollPosition = ScrollPosition()
   return (
      <div className='Floor flexCenter'>
         <img src={require("../../img/shop/2f.png")} alt="" />
         <div className={`${scrollPosition >= 550 ? 'originPosition' : ''}`}>
            <h2>site.A     SHOP LCDC</h2>
            <Swiper className='ShopSlide-cover' style={{
                "--swiper-pagination-color": "lavender",
                "--swiper-navigation-color": "lavender",
            }}
              // install Swiper modules
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              slidesPerView={1} navigation loop = {true}
              pagination={{ clickable: true }}
              scrollbar={{ draggable: true }}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log('slide change')}
            >
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/leconte-01.jpg")} alt="슬라이드 이미지1" /> </SwiperSlide>
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/leconte-02.jpg")} alt="슬라이드 이미지2" /> </SwiperSlide>
            </Swiper>
            <img src={require("../../img/logo/logo_lcdc.png")} alt='' style={{width:'150px'}} />
            <p>르콩트 드콩트(LE CONTE DES CONTES)는 ‘이야기 속의 이야기’라는 뜻으로 우리의 삶의 이야기, 그리고 그 속에 존재하는 크고 작은 여행의 이야기를 말하고 있습니다. 우리의 이야기를 들여다보면, 우리는 삶의 대서사시를 살고 있습니다.</p>
            <p>그 안의 여행은 우리 삶 속의 작은 이야기로 자리합니다. 삶이라는 이야기 속의 여행이라는 이야기. 삶 속의 여행. 여행 속의 삶. 여행은 다양한 이야기를 만들어 내고, 그 이야기는 다시 삶이라는 큰 이야기를 이룹니다.</p>
            <p>삶과 여행의 경계는 흐려지고 서로가 서로의 이야기를 만들어 냅니다. 르콩트 드콩트에서는 일상 속에서 여행의 이야기를 발견할 수 있고, 여행 중에 새로운 삶의 이야기를 만들어낼 수 있도록 노력합니다. 이야기가 만들어지는 과정, 즉 끊임없이 펼쳐지는 이야기들이 중첩되고 반복되며 또 다른 이야기들을 만들어간다는 관점에 집중하고 있습니다. 태도와 가치관에서 어떤 모티프를 통해 어떤 이야기를 만들어낼 수 있는지 패션과 라이프스타일을 제안하고 큐레이션 하고 있습니다.</p>
            <p className="mb60">SHOP LCDC 안에서 여러분의 삶과 여행의 이야기를 만들어보시기를 바랍니다.</p>

            <span>Directions: A동 2층</span>
            <span className="mb20">Opening hours: 11:00AM ~ 20:00PM (연중무휴)</span>
            <a className="link-arrow" href="noscrupt:">E,SHOP</a>
            <a className="link-arrow" href="noscrupt:">INSTAGRAM</a>
         </div>
      </div>
   )
}

export default F2floor
